import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DeltaChipComponent } from '../delta-chip/delta-chip.component';

/** KPI card: label + big value + optional deltas + optional projected content. */
@Component({
  selector: 'app-kpi-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeltaChipComponent],
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss',
})
export class KpiCardComponent {
  label = input.required<string>();
  value = input.required<string>();
  sub = input<string | null>(null);
  badge = input<string | null>(null);
  mom = input<number | null | undefined>(undefined);
  yoy = input<number | null | undefined>(undefined);
  invert = input<boolean>(false);
}
